import { render, staticRenderFns } from "./ViewCandidateProfile.vue?vue&type=template&id=210b7866&scoped=true&"
import script from "./ViewCandidateProfile.vue?vue&type=script&lang=ts&"
export * from "./ViewCandidateProfile.vue?vue&type=script&lang=ts&"
import style0 from "./ViewCandidateProfile.vue?vue&type=style&index=0&id=210b7866&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210b7866",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VCol,VIcon,VProgressCircular,VRow,VSkeletonLoader})
